/**
 * @generated SignedSource<<ad042ccb561b166302ff7ac41d639c75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteValveFamilyInput = {
  valveFamilyId: string;
  clientMutationId?: string | null;
};
export type ValveFamiliesTableDeleteValveFamilyMutation$variables = {
  input: DeleteValveFamilyInput;
};
export type ValveFamiliesTableDeleteValveFamilyMutationVariables = ValveFamiliesTableDeleteValveFamilyMutation$variables;
export type ValveFamiliesTableDeleteValveFamilyMutation$data = {
  readonly deleteValveFamily: {
    readonly valveFamily: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type ValveFamiliesTableDeleteValveFamilyMutationResponse = ValveFamiliesTableDeleteValveFamilyMutation$data;
export type ValveFamiliesTableDeleteValveFamilyMutation = {
  variables: ValveFamiliesTableDeleteValveFamilyMutationVariables;
  response: ValveFamiliesTableDeleteValveFamilyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteValveFamilyPayload",
    "kind": "LinkedField",
    "name": "deleteValveFamily",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveFamily",
        "kind": "LinkedField",
        "name": "valveFamily",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValveFamiliesTableDeleteValveFamilyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValveFamiliesTableDeleteValveFamilyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "866cba42c39c05a4e57d1ef27fb4a87d",
    "id": null,
    "metadata": {},
    "name": "ValveFamiliesTableDeleteValveFamilyMutation",
    "operationKind": "mutation",
    "text": "mutation ValveFamiliesTableDeleteValveFamilyMutation(\n  $input: DeleteValveFamilyInput!\n) {\n  deleteValveFamily(input: $input) {\n    valveFamily {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f408df248ce1fda9dca1b1da77fd6b7";

export default node;
